import { Link, Outlet } from 'react-router-dom';

/**
 * Layout para páginas legales públicas (sin necesidad de login)
 * Estilo consistente con el dark theme de la app
 */
const LegalLayout = () => {
    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
            color: '#e2e8f0'
        }}>
            {/* Header */}
            <header style={{
                padding: '1rem 1.5rem',
                borderBottom: '1px solid rgba(56, 189, 248, 0.15)',
                background: 'rgba(15, 23, 42, 0.8)',
                backdropFilter: 'blur(12px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <Link to="/" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    textDecoration: 'none',
                    color: '#38bdf8',
                    fontWeight: 700,
                    fontSize: '1.1rem'
                }}>
                    🚌 TUVISA Calendar
                </Link>
                <Link to="/login" style={{
                    color: '#94a3b8',
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    padding: '0.4rem 1rem',
                    borderRadius: '0.5rem',
                    border: '1px solid rgba(148, 163, 184, 0.3)',
                    transition: 'all 0.2s'
                }}
                    onMouseEnter={e => {
                        e.target.style.borderColor = 'rgba(56, 189, 248, 0.5)';
                        e.target.style.color = '#38bdf8';
                    }}
                    onMouseLeave={e => {
                        e.target.style.borderColor = 'rgba(148, 163, 184, 0.3)';
                        e.target.style.color = '#94a3b8';
                    }}
                >
                    Iniciar sesión
                </Link>
            </header>

            {/* Content */}
            <main style={{
                maxWidth: '800px',
                margin: '0 auto',
                padding: '2rem 1.5rem 4rem'
            }}>
                <Outlet />
            </main>

            {/* Footer with legal links */}
            <footer style={{
                borderTop: '1px solid rgba(56, 189, 248, 0.1)',
                padding: '1.5rem',
                textAlign: 'center',
                background: 'rgba(15, 23, 42, 0.6)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '1.5rem',
                    flexWrap: 'wrap',
                    marginBottom: '0.75rem'
                }}>
                    <Link to="/privacidad" style={{ color: '#64748b', textDecoration: 'none', fontSize: '0.85rem' }}>
                        Política de Privacidad
                    </Link>
                    <Link to="/cookies" style={{ color: '#64748b', textDecoration: 'none', fontSize: '0.85rem' }}>
                        Política de Cookies
                    </Link>
                    <Link to="/legal" style={{ color: '#64748b', textDecoration: 'none', fontSize: '0.85rem' }}>
                        Aviso Legal
                    </Link>
                </div>
                <p style={{ color: '#475569', fontSize: '0.8rem', margin: 0 }}>
                    © {new Date().getFullYear()} TUVISA Calendar — calendario.xerp.es
                </p>
            </footer>
        </div>
    );
};

export default LegalLayout;
